import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface PageTabItem {
  label: string;
  route: RoutesEnum;
}
type PageTabNavigationProps = {
  pageTabs: PageTabItem[];
};

const useRouteMatch = (patterns: readonly string[]) => {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
};

const PageTabNavigation = (props: PageTabNavigationProps) => {
  const { pageTabs } = props;
  const { t } = useTranslation();
  const routeMatch = useRouteMatch(pageTabs.map((x) => x.route)); // Order is important here, read documentation on MUI
  const currentTab = routeMatch?.pattern?.path;

  return (
    <>
      <Tabs value={currentTab}>
        {pageTabs.map((item) => (
          <Tab label={t(item.label)} key={item.route} value={item.route} to={item.route} component={Link as any} />
        ))}
      </Tabs>
      <Divider />
    </>
  );
};
export default PageTabNavigation;
